<div class="header">

    <a class="logo" routerLink="/">
        <img src="../assets/logo.png" alt="WAGAS - Handlowcy">
        <span>Sales Support System</span>
    </a>

</div>
<ns-template-window>

    <div class="main">

        <div class="subtitle">
            <div class="big">Logowanie</div>
            <span>do Sales Support System</span>
        </div>
        <form (ngSubmit)="onSubmit()" [formGroup]="form">
            <div class="center-row">
                <div class="fields">
                    <cmn-label labelText="E-mail" labelPosition="top" labelWidth="100%">
                        <input formControlName="username" autocomplete="off" kendoTextBox/>
                        <cmn-errors [control]="form.get('username')"></cmn-errors>
                    </cmn-label>
                    <cmn-label labelText="Hasło" labelPosition="top" labelWidth="100%">
                        <input formControlName="password" type="password" autocomplete="off" kendoTextBox/>
                        <cmn-errors [control]="form.get('password')"></cmn-errors>
                    </cmn-label>
                    <div class="action-row">
                        <button kendoButton type="button" (click)="goToForgotPassword()" class="forgot-button">Zapomniałem hasła</button>
                        <button type="submit" kendoButton [primary]="false" class="login-button">Zaloguj się</button>
                    </div>
                </div>


            </div>
        </form>


    </div>

    <div class="qr" *ngIf="showQR">
        <div class="qr-header">
            Zaloguj się przez aplikację
        </div>
        <div class="qr-code-wrap">
            <p>Zeskanuj kod QR<br> aplikacją Wagas</p>
            <img [src]="'data:image/png;base64,' + qrData?.qrCode" alt="">
        </div>
        <a href="https://play.google.com/store/apps/details?id=pl.wagas.meso&gl=PL" target="_blank" class="gs-wrapper">
            <img src="assets/google-play.png"
                 class="store"
            >
        </a>
        <a href="https://apps.apple.com/pl/app/wagas-ubezpieczenia/id1511529279" target="_blank">
            <img src="assets/apple-store.png"
                 class="store"
            >
        </a>
    </div>

</ns-template-window>
